class TabindexHelper {
    constructor() {
        this.init();
    }

    init() {
        const observer = new MutationObserver(function (mutationsList) {
            mutationsList.forEach(mutation => {
                if (mutation.type === 'childList') {
                    const footerNav = document.querySelector('nav.footer-navigation.nav[aria-label="service"]');
                    if (footerNav) {
                        const menuLinks = footerNav.querySelectorAll('a');
                        menuLinks.forEach(link => {
                            link.setAttribute('tabindex', '0'); // Replace '0' with desired tabindex value
                        });
                        observer.disconnect(); // Stop observing once the menu is processed
                    }

                    const sideNav = document.querySelector('nav.sidenav__wrapper.sidenav__wrapper--second[aria-label="Secondary Menu"]');
                    if (sideNav) {
                        const menuLinks = sideNav.querySelectorAll('a');
                        menuLinks.forEach(link => {
                            link.setAttribute('tabindex', '0'); // Replace '0' with desired tabindex value
                        });
                        observer.disconnect(); // Stop observing once the menu is processed
                    }
                }
            });
        });

        // Start observing the body for changes
        observer.observe(document.body, {
            childList: true,
            subtree: true // Look at all child nodes, not just direct children
        });
    }
}

export default TabindexHelper;
